<p-confirmDialog />
<div class="version-list-container">
  <div class="header">
    <h1>Changelog Versions</h1>
    <button pButton icon="pi pi-plus" label="Add New Version" class="p-button-primary" (click)="addVersion()">
    </button>
  </div>

  <div *ngIf="loading" class="loading">
    Loading versions...
  </div>

  <div *ngIf="!loading && versions.length === 0" class="no-data">
    No versions found. Click "Add New Version" to create one.
  </div>

  <div *ngIf="!loading && versions.length > 0" class="version-table">
    <table>
      <thead>
        <tr>
          <th>Version</th>
          <th>Title</th>
          <th>Role</th>
          <th>Language</th>
          <th>Release Date</th>
          <th>Last Changed</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let version of versions">
          <td class="version-number">
            <strong>{{ getVersionNumber(version) }}</strong>
          </td>
          <td>{{ version.title || '-' }}</td>
          <td>
            <span class="role-badge" *ngFor="let role of version.role">
              {{ role }}
            </span>
          </td>
          <td>{{ version.language }}</td>
          <td>{{ formatDate(version.releaseDate) }}</td>
          <td>
            <div class="changed-info">
              <div>{{ formatDate(version.changedAt) }}</div>
              <div class="changed-by">by {{ version.changedBy }}</div>
            </div>
          </td>
          <td class="actions">
            <button pButton icon="pi pi-pencil" class="p-button-secondary mr-2" (click)="editVersion(version.id)" title="Edit">
            </button>
            <button pButton icon="pi pi-trash" severity="danger" (click)="deleteVersion(version)" title="Delete">
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
